import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Calendar, ArrowRight } from 'lucide-react';

const Hero = () => {
  const navigate = useNavigate();

  return (
    <section className="hero-section">
      <div className="hero-container">
        <div className="hero-badge">
          <span className="icon">⚡</span>
          <span>Patient Portal Solution</span>
        </div>
        
        <h1 className="hero-title">
          Modern Medical Portals <span className="hero-title-gold">Made Simple</span>
        </h1>
        
        <p className="hero-description">
          Streamline your medical practice with our easy-to-use portals. Manage appointments, billing, and patient data all in one secure platform.
        </p>
        
        <div className="hero-buttons">
          <button 
            className="btn-primary"
            onClick={() => navigate('/signup')}
          >
            Start Free Trial <ArrowRight size={20} />
          </button>
          <button className="btn-secondary">
            Watch Demo
          </button>
        </div>
        
        <div className="stats-grid">
          <div className="stat-item">
            <span className="stat-number">500+</span>
            <span className="stat-label">Medical Practices</span>
          </div>
          <div className="stat-item">
            <span className="stat-number">99.9%</span>
            <span className="stat-label">Uptime</span>
          </div>
          <div className="stat-item">
            <span className="stat-number">24/7</span>
            <span className="stat-label">Support</span>
          </div>
          <div className="stat-item">
            <span className="stat-number">HIPAA</span>
            <span className="stat-label">Compliant</span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
